import React from 'react'


import Styles from "./adminRelatif.module.scss";
import { Button, Form, FormGroup, Label, Container } from 'reactstrap';
import RelatifService from 'services/relatifService';
import Editor from 'components/common/editor/editor';
interface IAdminRelatifProps {

}

interface IAdminRelatifState {
    relatif: string
}

class AdminRelatif extends React.Component<IAdminRelatifProps, IAdminRelatifState> {
    /**
     *
     */
    constructor(props: IAdminRelatifProps) {
        super(props);

        this.state = { relatif: '' };
    }


    componentDidMount() {
        this.load();
    }

    load() {
        RelatifService.GetRelatif()
            .then(value => {
                this.setState({ relatif: value });
            })
    }

    saveRelatif(rel: string) {
        RelatifService.SetRelatif(rel).then(this.load.bind(this));
    }

    render() {
        return <div className={Styles.AdminRelatif}>
            <Container>
                <div className={Styles.Edition}>
                    <Form>

                        <FormGroup>
                            <Label for="inputContent">Contenu</Label>
                            <Editor onChange={(newText) => {
                                    this.setState({ relatif: newText.target.getContentAreaContainer().innerHTML })
                            }} initialValue={this.state.relatif} />

                        </FormGroup>
                    </Form>
                    
                    <div className="mt-5 text-right">
                        <Button color="danger" onClick={() => this.setState({ relatif: '' })} className="mr-3">Annuler</Button>
                        <Button color="primary" onClick={this.saveRelatif.bind(this, this.state.relatif)}>Sauvegarder</Button>
                    </div>
                </div>
            </Container>
        </div>
    }
}

export default AdminRelatif;